import {Tooltip} from "@mui/material";

const CustomTooltip = ({title, children}) => {
    return <Tooltip arrow title={title}>
        <span>{children}</span>
    </Tooltip>
}

export default CustomTooltip